// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"597ed60d","353":"f4146e3a","435":"7b7c891d","590":"92ea2ae6","594":"09ec128c","619":"15f270e2","676":"cea83d84"}[chunkId] + ".chunk.js";
};